import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {InvitationPreview, LegacyClaimStatus} from './migration.models';

/**
 * Talks to the legacy-login migration endpoints (#279): the current session's migration state, the offer to
 * switch password login off, and the anonymous invitation preview behind an invite link.
 *
 * Transitional — deleted together with the legacy authorization system at #264.
 */
@Injectable({providedIn: 'root'})
export class MigrationHttpService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  /** Whether this session still runs on legacy credentials, and who has already claimed it. */
  status(): Observable<LegacyClaimStatus> {
    return this.http.get<LegacyClaimStatus>(`${this.baseUrl}/auth/migration/status`);
  }

  /**
   * Records on the server that this session has closed the migration notice (#854), so the status stops
   * prompting for it in every tab and after every reload. Idempotent.
   */
  noticeSeen(): Observable<{ seen: boolean }> {
    return this.http.post<{ seen: boolean }>(`${this.baseUrl}/auth/migration/notice-seen`, {});
  }

  /** Switches password login off for the current login, once an account can open it. */
  disablePassword(): Observable<{ disabled: boolean }> {
    return this.http.post<{ disabled: boolean }>(`${this.baseUrl}/auth/migration/disable-password`, {});
  }

  /**
   * What an invitation offers, before signing in to accept it. Anonymous: since #279 an account is created BY
   * redeeming, so requiring a session here would be circular.
   */
  previewInvitation(code: string): Observable<InvitationPreview> {
    return this.http.get<InvitationPreview>(
      `${this.baseUrl}/grants/redeem/preview?code=${encodeURIComponent(code)}`);
  }
}
